import http from 'plugins/axios'

export default {
  getTradeStatistic(data) {
    return http.get({
      url: `/la/admin/getTradeStatistic`,
      data,
    })
  },
  tradeCharts(data) {
    return http.post({
      url: `/la/admin/statistics/trade/charts`,
      data,
    })
  },

  topChannelList(data) {
    return http.get({
      url: `/la/admin/channel/common/topChannelList`,
      data,
    })
  },
  userTradeInfo(data) {
    return http.get({
      url: `/la/admin/channel/tiger/userTradeInfo`,
      data,
    })
  },
  //数据汇总
  getTradeStatisticTotal(data) {
    return http.get({
      url: `/la/admin/getTradeStatistic/total`,
      data,
    })
  },
  /** 提现审批列表（与审批-提现审批同源，用于交易统计穿透查看内部转帐等记录） */
  searchWithdrawAuditRecords(data) {
    return http.get({
      url: '/la/admin/workorder/search_withdraw',
      data,
    })
  },
}
